import { render } from "./TaxRateItem.vue?vue&type=template&id=f2456bb4"
import script from "./TaxRateItem.vue?vue&type=script&lang=js"
export * from "./TaxRateItem.vue?vue&type=script&lang=js"

import "./TaxRateItem.vue?vue&type=style&index=0&id=f2456bb4&lang=css"
script.render = render

export default script